import { IconNameEnum } from "@b2bportal/core-themes";
import {
  type DisruptionOfferComponentProps,
  DisruptionOfferSectionV2,
} from "@tenant/disruption";

export const DisruptionOfferSection = (
  props: DisruptionOfferComponentProps
) => {
  return (
    <DisruptionOfferSectionV2
      {...props}
      bulletLines={{
        1: {
          icon: {
            iconName: IconNameEnum.disruptionBulletPointOne,
            viewBox: "0 0 16 16",
          },
        },
        2: {
          icon: {
            iconName: IconNameEnum.disruptionBulletPointTwo,
            viewBox: "0 0 22 16",
          },
        },
        3: {
          icon: {
            iconName: IconNameEnum.disruptionBulletPointThree,
            viewBox: "0 0 18 18",
          },
        },
      }}
    />
  );
};
